import React from 'react';
import {
  ButtonWithGAClickButton,
  List,
  ListItem,
  SectionSubTitle,
  SectionTitle,
  Typography,
} from 'common/components';
import { ServicePrice } from 'modules/services';
import { createElementKey } from 'utils/create-element-key';
import { formatToRub } from 'utils/format';
import { ENGINEERING_SYSTEMS_CDN_PATH } from '../../engineering-systems-constants';
import { DownloadExampleLink } from '../download-example-link';
import {
  developmentCompositionBlock,
  developmentCompositionTitle,
  developmentExampleLink,
  developmentPrice,
  developmentSchedule,
  developmentComposition,
  projectDevelopmentContainer,
  projectDevelopmentDescription,
  projectDevelopmentSection,
  projectDevelopmentTitle,
  scheduleBlock,
  scheduleIcon,
  scheduleInfoBlock,
} from './project-development-section-styles';
import { ProjectDevelopmentStructure } from './project-development-section-types';

type ProjectDevelopmentSectionProps = {
  elementBlock: string;
  onConsultationSignupBtnClick: () => void;
  projectDevelopmentInfo: ProjectDevelopmentStructure;
  serviceTypePrice: ServicePrice | null;
};

/**
 * Вью секции с описание услуги разработки системы
 */
export const ProjectDevelopmentSection = ({
  elementBlock,
  onConsultationSignupBtnClick,
  projectDevelopmentInfo,
  serviceTypePrice,
}: ProjectDevelopmentSectionProps) => (
  <section className={projectDevelopmentSection} itemScope itemType="https://schema.org/Product">
    <SectionTitle className={projectDevelopmentTitle} itemProp="name">
      {projectDevelopmentInfo.title}
    </SectionTitle>
    <Typography
      className={projectDevelopmentDescription}
      itemProp="description"
      variant="m"
      size="body_long">
      {projectDevelopmentInfo.description}
    </Typography>

    <div className={projectDevelopmentContainer}>
      <div className={scheduleBlock}>
        <div className={scheduleInfoBlock} itemProp="offers" itemScope itemType="https://schema.org/Offer">
          {serviceTypePrice && serviceTypePrice[projectDevelopmentInfo.id] && (
            <SectionSubTitle as="h3" className={developmentPrice} margin="s">
              {!projectDevelopmentInfo.fixedPrice && <span>от </span>}
              <span itemProp="price" content={serviceTypePrice[projectDevelopmentInfo.id].toFixed(2)}>
                {formatToRub(serviceTypePrice[projectDevelopmentInfo.id])}{' '}
              </span>
              <span itemProp="priceCurrency" content="RUB">
                ₽
              </span>
              {projectDevelopmentInfo.priceUnits && <span>{projectDevelopmentInfo.priceUnits}</span>}
            </SectionSubTitle>
          )}
          <div className={developmentSchedule}>
            <img
              alt=""
              className={scheduleIcon}
              src="https://cdn.lemanapro.ru/lmru/image/upload/fudzi/elbrus/images/landings/engineering-systems/heating/3.svg/3.svg"
              title=""
            />
            <Typography variant="m" size="body_long">
              {projectDevelopmentInfo.schedule}
            </Typography>
          </div>
        </div>
        <ButtonWithGAClickButton
          elementBlock={elementBlock}
          elementText="Записаться на консультацию"
          elementName={projectDevelopmentInfo.title}
          onClick={onConsultationSignupBtnClick}>
          Записаться на консультацию
        </ButtonWithGAClickButton>
      </div>

      <div className={developmentCompositionBlock}>
        <Typography adaptive={false} className={developmentCompositionTitle} variant="m" size="body_short">
          В&nbsp;услугу входит:
        </Typography>
        <List className={developmentComposition}>
          {projectDevelopmentInfo.compositionList.map((composition, index) => (
            <ListItem
              key={createElementKey('projectDevelopmentComposition', index)}
              text={composition}
              variant="s"
            />
          ))}
        </List>
      </div>

      <DownloadExampleLink
        className={developmentExampleLink}
        elementBlock={elementBlock}
        elementText={projectDevelopmentInfo.title}
        href={projectDevelopmentInfo.exampleHref}
        label="Скачать пример проектной сметы"
        src={`${ENGINEERING_SYSTEMS_CDN_PATH}/filter/example-icon.png/example-icon.png`}
      />
    </div>
  </section>
);
